<template>
  <div class="question">
    <div class="question__wrapper">
      <div class="question__q">
        Q: {{ currentPosition }}/{{ totalQuestions }}
      </div>
      <div
        class="question__content"
        v-html="currentQuestion.content || currentQuestion.question_html"
        v-replace-imgs
      ></div>
      <div v-if="displayLabHelperText" class="question__lab-helper">
        {{ labHelperText }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DraggableImage from '@/components/shared/DraggableImage.vue'

function draggableImages(el) {
  const imgs = el.querySelectorAll('img')
  imgs.forEach(img => {
    if (img.__replaced__) return

    const imgSrc = img.getAttribute('src')
    if (!imgSrc) return

    const draggableImageComponent = new (Vue.extend(DraggableImage))({
      propsData: { imgSrc, openRatio: 0.65 },
    }).$mount()

    img.__replaced__ = true
    img.replaceWith(draggableImageComponent.$el)
  })
}

Vue.directive('replace-imgs', {
  bind(el) {
    draggableImages(el)
  },
  componentUpdated(el) {
    draggableImages(el)
  },
})
export default {
  name: 'Question',
  props: {
    currentQuestion: {
      type: Object,
      required: true,
    },
    currentPosition: {
      type: Number,
      required: true,
    },
    totalQuestions: {
      type: Number,
      required: true,
    },
    isMCIT: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    labHelperText() {
      return `Navigate to question #${this.currentPosition} in the exam lab environment, complete the instructions, and enter the answer below.`
    },
    displayLabHelperText() {
      return this.currentQuestion?.is_lab_related && this.isMCIT
    },
  },
}
</script>

<style lang="scss">
.question {
  &__wrapper {
    box-shadow: none;
    @include desktop {
      flex-wrap: wrap;
    }
  }
  &__q {
    font-weight: 700;
    font-size: 32px;
    margin: 0 20px 0 0;
  }
  &__content {
    font-size: 1rem;
    margin: 0;
    padding: 20px 0 0 0;
    width: 100%;
    word-break: break-word;
    @include desktop {
      font-size: 22px;
      width: 100%;
      box-sizing: border-box;
      flex: 1;
    }
  }
  &__lab-helper {
    font-size: 20px;
    margin: 0;
    width: 100%;
    word-break: break-word;
    margin: 30px 0 0 0;
    padding-left: 20px;
    border-left: 4px solid var(--white);
  }
  img {
    max-width: 450px;
  }
}
</style>
